import angular from 'angular'

import templateUrl from './permission-list.component.html';

export const PermissionListComponent = {
    templateUrl,
    controller: class PermissionListController {
        constructor(utilityService, fileService, permissionGrantService, $state) {
            'ngInject'

            this.utilityService = utilityService;
            this.fileService = fileService;
            this.permissionGrantService = permissionGrantService;
            this.$state = $state;
        }
        $onInit() {
            this.filters = {};
            this.filteredClaimPermissions = this.claimPermissions;
            this.pageSize = 15;
            this.pageNumber = 1;

        }
        onChangeFilters() {
            this.filteredClaimPermissions = angular.copy(this.claimPermissions);
            this.filteredClaimPermissions = this.filteredClaimPermissions
                .filter(permission => this.filterPermission(permission));

        }

        onExport() {
            this.permissionGrantService.exportAllClaimPermissionsCsv();
        }

        onImport(importFile) {
            const saving = this.fileService.fileToPlainText(importFile)
                .then(csvString => this.permissionGrantService.importAllClaimPermissionsCsv(csvString))
                .then(() => this.$state.reload());
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(saving, "Importing file failed")
            );
        }

        filterPermission(permission) {
            return (!this.filters.PermissionKey || this.utilityService.containsInvariant(
                permission.Description.Key, this.filters.PermissionKey))
                && (!this.filters.Name || this.utilityService.containsInvariant(
                    permission.Description.Name, this.filters.Name))
                && (!this.filters.Description || this.utilityService.containsInvariant(
                    permission.Description.Description, this.filters.Description))
                && (!this.filters.Type || this.utilityService.containsInvariant(
                    permission.Description.Type, this.filters.Type))
                && (!this.filters.Value || this.utilityService.containsInvariant(
                    permission.Description.Value, this.filters.Value));
        }
    },
    controllerAs: "vm",
    bindings: {
        claimPermissions: "<"
    }
};
